<script>
import {formatDate} from "@/utils/data";
import {facilityList, refreshStbTemplate, wasteList} from "@/api/sync";
import {Message} from "element-ui";

export default {
  name: 'StbTemplate',
  data() {
    return {
      wasteList : [],
      facilityList : [],
      tableType : "WASTE",
      typeDialogVisible: false,
      typeTab: 'WASTE',
      wasteYear : null,
      facilityType : null,
      typeSubmitLoading : false,
      officeId : null,
    }
  },
  async mounted() {
    await this.getCacheOffice()
    this.fetchWasteList()
  },
  watch: {
    tableType (newValue,oldValue) {
      if (newValue !== oldValue){
        this.refreshList(newValue)
      }
    }
  },
  methods: {
    async getCacheOffice() {
      const user = localStorage.getItem('user')
      if ( user){
        const id = JSON.parse(user).sysAccount.officeId
        this.officeId = id
        this.oliSync.officeId = id
      }
      return Promise.resolve();
    },


    async handleRefresh(){
      this.typeSubmitLoading = true;
      const data = {
        template : this.typeTab,
        year: formatDate(this.wasteYear,'yyyy'),
        facilityType : this.facilityType
      }
      try {
        const resp = await refreshStbTemplate(data);
        if (resp && resp.code === "0000") {
          Message.success('刷新成功')
          await this.refreshList(this.tableType)
        }
      } catch (e) {
      }
      finally {
        this.typeSubmitLoading = false;
        this.typeDialogVisible = false;
      }

    },

    async refreshList(value){
      if (value === "WASTE"){
        await this.fetchWasteList();
      }else if (value === "FACILITY"){
        await this.fetchFacilityList();
      }
    },


    async fetchWasteList() {
      const param = {
        current : 1,
        size : 1000,
        sorted : [
            {
              name: 'createTime',
              type: 'DESC'
            }
        ]
      }
      const resp = await wasteList( param)
      if (resp && resp.code === "0000") {
        this.wasteList = resp.result.records;
      }
    },

    async fetchFacilityList() {
      const param = {
        current : 1,
        size : 1000,
        sorted : [
          {
            name: 'createTime',
            type: 'DESC'
          }
        ]
      }
      const resp = await facilityList( param)
      if (resp && resp.code === "0000") {
        this.facilityList = resp.result.records;
      }
    }
  }
}

</script>

<template>
  <div>
    <el-card>
      <el-row type="flex" justify="end">
          <el-button type="warning" size="small" @click="typeDialogVisible = true"  v-if="officeId !== 0">同步市平台模版</el-button>
      </el-row>
      <el-tabs v-model="tableType">
        <el-tab-pane label="废物信息" name="WASTE">
          <el-table :data="wasteList" border stripe highlight-current-row>
            <el-table-column label="年份" prop="year" fixed />
            <el-table-column label="废物大类编号" prop="fwdldm" />
            <el-table-column label="废物大类名称" prop="fwdlmc" />
            <el-table-column label="废物小类编号" prop="fwxldm" min-width="100"/>
            <el-table-column label="废物小类名称" prop="fwxlmc" min-width="120" show-overflow-tooltip/>
            <el-table-column label="废物详细名称" prop="fwxxmc" />
            <el-table-column label="物理性状、形态" prop="fwxz" />
            <el-table-column label="废物特性" prop="fwtx" min-width="100" show-overflow-tooltip/>
            <el-table-column label="创建时间" prop="createTime" min-width="120" show-overflow-tooltip/>
          </el-table>
        </el-tab-pane>

        <el-tab-pane label="贮存、利用处置设施信息数据" name="FACILITY">
          <el-table :data="facilityList" border stripe highlight-current-row>
            <el-table-column label="分类" prop="typeDesc" />
            <el-table-column label="生产设施名称" prop="scssmc" />
            <el-table-column label="生产设施编号" prop="scssbh" />
            <el-table-column label="生产能力" prop="scnl" />
            <el-table-column label="利用处置方式小类" prop="lyczfsxl" />
            <el-table-column label="利用处置方式大类" prop="lyczfsdl" />
            <el-table-column label="利用处置设施类型" prop="sslx" />
            <el-table-column label="创建时间" prop="createTime" min-width="120" show-overflow-tooltip />
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-card>



    <el-dialog :visible.sync="typeDialogVisible" title="更新市平台模版数据" width="500">
      <el-tabs v-model="typeTab" style="height: 20vh">
        <el-tab-pane label="危废管理计划-废物信息" name="WASTE">
          <el-date-picker
              v-model="wasteYear"
              type="year"
              placeholder="选择年份" />
        </el-tab-pane>
        <el-tab-pane label="贮存、利用处置设施信息数据" name="FACILITY">
          <el-radio-group v-model="facilityType">
            <el-radio label="STORAGE">贮存</el-radio>
            <el-radio label="DISPOSAL">利用处置</el-radio>
          </el-radio-group>
        </el-tab-pane>
      </el-tabs>
      <el-row type="flex" justify="end" >
        <el-button type="primary" :loading="typeSubmitLoading" @click="handleRefresh">提交更新</el-button>
      </el-row>
    </el-dialog>
  </div>

</template>

<style scoped>

</style>
